import { render, staticRenderFns } from "./PayrollExpensesList.vue?vue&type=template&id=58b4554c"
import script from "./PayrollExpensesList.vue?vue&type=script&lang=js"
export * from "./PayrollExpensesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports